import type { Client } from '@core/types';

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function csvEscapeCell(v: string): string {
  if (/[,"\r\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

/** Toolbar / Operations menu: downloads UTF-8 CSV of client rows with job & app counts when known. */
export function downloadClientsCsv(
  rows: Client[],
  stats: Record<string, { jobs: number; applications: number }>,
  maskingNames: Record<string, string>,
) {
  const headers = ['id', 'name', 'domain', 'contact_email', 'industry', 'jobs', 'applications', 'masking', 'created_at'];
  const headerLine = headers.join(',');
  const lines = rows.map((c) => {
    const st = stats[c.id];
    const mask = c.default_masking_template_id ? maskingNames[c.default_masking_template_id] ?? '' : 'Default';
    const cells = [
      c.id,
      c.name ?? '',
      c.domain ?? '',
      c.contact_email ?? '',
      c.industry ?? '',
      String(st?.jobs ?? 0),
      String(st?.applications ?? 0),
      mask,
      c.created_at ?? '',
    ];
    return cells.map((x) => csvEscapeCell(String(x))).join(',');
  });
  const stamp = new Date().toISOString().slice(0, 10);
  const content = '\ufeff' + [headerLine, ...lines].join('\n');
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  triggerDownload(blob, `clients-${stamp}.csv`);
}
